<template>
    <div>
        <div ref="gmapsPh" class="gmapsPh"></div>
        <small v-show="showLocationAccuracyInfo">{{textLocationAccuracyInfo}}</small>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import gmapsInit from './googleMapsInit';

const props = defineProps({
    locationData: Object,
});

const zoomLevel = ref(12);
const googleMaps = ref(null);
const lang = ref({});

const gmapsPh = ref(null);

const loadGoogleMapsScript = async () => {
    try {
        googleMaps.value = await gmapsInit();
        geocodeAddress();
    } catch (error) {
        console.error(error);
    }
};

const geocodeAddress = () => {
    let geocoder = new googleMaps.value.maps.Geocoder();

    if (props.locationData.addressString == '') {
        return;
    }

    geocoder.geocode({ 'address': props.locationData.addressString }, (results, status) => {
        if (status == 'OK') {
            let geocodeLocation = results[0].geometry.location;
            renderMap(geocodeLocation);
        } else {
            console.log('Geocode was not successful for the following reason: ' + status);
        }
    });
};

const renderMap = (geocodeLocation) => {
    let markerLabel = (props.locationData.markerLabel !== undefined) ? props.locationData.markerLabel : '';
    let infoWindow = new googleMaps.value.maps.InfoWindow();

    let mapOptions = {
        zoom: zoomLevel.value,
        center: geocodeLocation,
        mapTypeId: googleMaps.value.maps.MapTypeId.ROADMAP,
        styles: [{"featureType": "landscape", "stylers": [{"hue": "#F1FF00"}, {"saturation": -27.4 }, {"lightness": 9.4 }, {"gamma": 1 } ] }, {"featureType": "road.highway", "stylers": [{"hue": "#0099FF"}, {"saturation": -20 }, {"lightness": 36.4 }, {"gamma": 1 } ] }, {"featureType": "road.arterial", "stylers": [{"hue": "#00FF4F"}, {"saturation": 0 }, {"lightness": 0 }, {"gamma": 1 } ] }, {"featureType": "road.local", "stylers": [{"hue": "#FFB300"}, {"saturation": -38 }, {"lightness": 11.2 }, {"gamma": 1 } ] }, {"featureType": "water", "stylers": [{"hue": "#00B6FF"}, {"saturation": 4.2 }, {"lightness": -63.4 }, {"gamma": 1 } ] }, {"featureType": "poi", "stylers": [{"hue": "#9FFF00"}, {"saturation": 0 }, {"lightness": 0 }, {"gamma": 1 } ] } ],
    };

    googleMaps.value.maps.visualRefresh = true;
    let map = new googleMaps.value.maps.Map(gmapsPh.value, mapOptions);

    let marker = new googleMaps.value.maps.Marker({
        map: map,
        animation: googleMaps.value.maps.Animation.DROP,
        position: geocodeLocation
    });

    if (markerLabel != '') {
        googleMaps.value.maps.event.addListener(marker, 'click', ((map, marker) => {
            return () => {
                infoWindow.setContent(markerLabel);
                infoWindow.open(map, marker);
            };
        })(map, marker));
    }
};

const loadLanguageData = () => {
    axios.get(`/web-api/language`, {
            params: {
                section: 'googleMaps'
            }
        })
        .then(response => {
            lang.value = response.data.lang;
        })
        .catch(error => {
            // console.log(error)
        });
};

const showLocationAccuracyInfo = computed(() => {
    if (props.locationData.accuracy === 'zipCity') {
        return true;
    }
    return false;
});

const textLocationAccuracyInfo = computed(() => {
    if (_.isEmpty(lang.value)) {
        return '';
    }

    return lang.value.modals.single_maps_location.description;
});

onMounted(() => {
    loadLanguageData();
    loadGoogleMapsScript();
});
</script>
    
<style scoped>
    /* Scoped Styles */
    .gmapsPh{
        height: 350px;
        margin-top: 10px;
    }
</style>